/* ============================================================
   glow-cart.js — לוגיקת העגלה של Glow (גל C):
   (1) הוספה מהירה מכרטיסי ה-related בעגלה (AJAX /cart/add → refresh drawer)
   (2) <glow-cart-carousel> — קרוסלה מעגלית (infinite loop דו-כיווני) ל-related
   (2.5) נרמול NIS → ש"ח בהקשר העגלה
   (3) אנליטיקה — glow_checkout_click (מדד-על) על קליק "לתשלום"

   נשען על מנגנוני Symmetry הקיימים:
   - theme.routes.cartAdd / window.Shopify.routes.root
   - dispatch:cart-drawer:refresh (cart-drawer.js) לרענון ה-drawer אחרי add
   ============================================================ */
(function () {
  'use strict';

  var CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root : '/';
  var CART_ADD_URL = CART_ROOT + 'cart/add.js';

  /* ---------- (1) הוספה מהירה מכרטיסי related ---------- */

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true, cancelable: false
    }));
    /* fallback: אם ה-cart page פתוח (לא drawer) — רענן את ה-cart-form שם */
    if (document.querySelector('.template-cart')) {
      var cf = document.querySelector('cart-form');
      if (cf && typeof cf.refresh === 'function') cf.refresh();
    }
  }

  /* אנליטיקה — glow_add_to_cart עם ייחוס-מקור. added = תשובת cart/add.js
     (ה-line-item שנוסף) = מקור-האמת לפריט: product_id / product_title / handle /
     product_type / price(בסנטים) / quantity. משדרים במוסכמת השדות ש-glowItem
     בפיקסל קורא (product_id / product_title / handle / item_category / price) —
     **לא** item_id/item_name (אחרת items[] בפיקסל ייבנה ריק). item_list_name מגיע
     מ-data-glow-list על הכפתור. value = מחיר יחידה אחת (הפיקסל קורא d.value ברמת-אירוע):
     quickAdd מוסיף תמיד 1, וזה גם מחיר הסולם ל-1. ⚠️ לא added.quantity: על שורה שכבר בעגלה
     התשובה מחזירה את הסך החדש של השורה, לא את מה שנוסף (תיעוד cart/add.js).
     guard מלא + try/catch — אנליטיקה לעולם לא שוברת את ה-add. */
  function publishAddToCart(btn, added) {
    if (!window.Shopify || !window.Shopify.analytics
      || typeof window.Shopify.analytics.publish !== 'function') return;
    if (!added || !added.product_id) return;
    try {
      var qty = added.quantity || 1;
      var rawPrice = (typeof added.price === 'number') ? added.price : parseFloat(added.price);
      var price = (isNaN(rawPrice) ? 0 : rawPrice) / 100; /* סנטים → ש"ח */
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ILS';
      window.Shopify.analytics.publish('glow_add_to_cart', {
        item_list_name: btn.getAttribute('data-glow-list') || '',
        product_id: added.product_id,
        product_title: added.product_title,
        handle: added.handle,
        item_category: added.product_type || '',
        price: price,
        quantity: qty,
        value: price,
        currency: currency
      });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }

  function quickAdd(btn) {
    if (btn.hasAttribute('aria-busy')) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed: ' + response.status);
        return response.json();
      })
      .then(function (added) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        /* אנליטיקה — glow_add_to_cart (ייחוס-מקור). לא-קריטי, לא חוסם את ה-add. */
        publishAddToCart(btn, added);
        /* מפעיל את כל שרשרת ה-cart של Glow: refresh → section-render →
           merge → on:cart:after-merge → glow-cart-gate מעדכן חיסכון/מחיר/שער */
        refreshCartDrawer();
        setTimeout(function () { btn.classList.remove('is-success'); }, 1600);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        // eslint-disable-next-line no-console
        console.log('[glow-cart] quick-add', err && err.message);
        setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
      });
  }

  /* delegation גלובלי — עובד גם על כרטיסים שהוזרקו ע"י cc-cart-cross-sell */
  document.addEventListener('click', function (evt) {
    var addBtn = evt.target.closest('[data-glow-quick-add]');
    if (addBtn) {
      evt.preventDefault();
      quickAdd(addBtn);
      return;
    }
  });

  /* אנליטיקה בלבד — glow_select_item על קליק בכרטיס related בעגלה ("אולי יעניין
     אתכם"). passive: בלי preventDefault (הניווט נשמר כמות שהוא). handle מ-data-glow-handle.
     delegation → עובד גם על כרטיסים דינמיים (cc-cart-cross-sell). לא-קריטי. */
  document.addEventListener('click', function (evt) {
    var recLink = evt.target.closest('.glow-cart-related-card__link');
    if (!recLink) return;
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish('glow_select_item', {
        handle: recLink.getAttribute('data-glow-handle') || '',
        list: 'cart_recs'
      });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  });

  /* אנליטיקה — glow_select_item לקרוסלות הניווטיות (כרטיס→PDP, בלי ATC):
     best_sellers (קרוסלת הבית) + search_bestsellers (פאנל "הנמכרים שלנו" בחיפוש).
     passive: בלי preventDefault (הניווט נשמר). delegation גלובלי — glow-cart.js
     נטען בכל עמוד דרך ה-cart-drawer בהדר. handle מ-data-glow-handle. לא-קריטי. */
  document.addEventListener('click', function (evt) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var bsLink = evt.target.closest('.best-sellers-arc__link[data-glow-handle]');
    if (bsLink) {
      try {
        window.Shopify.analytics.publish('glow_select_item', {
          handle: bsLink.getAttribute('data-glow-handle') || '',
          list: 'best_sellers'
        });
      } catch (e) { /* אנליטיקה לא-קריטית */ }
      return;
    }
    var srItem = evt.target.closest('.search-recommendations--glow-products .search-recommendations__item[data-glow-handle]');
    if (srItem) {
      try {
        window.Shopify.analytics.publish('glow_select_item', {
          handle: srItem.getAttribute('data-glow-handle') || '',
          list: 'search_bestsellers'
        });
      } catch (e) { /* אנליטיקה לא-קריטית */ }
    }
  });

  /* אנליטיקה — glow_add_to_cart למסלול ה-PDP הראשי (pdp_main). טופס-המוצר הנייטיבי
     של Symmetry עושה AJAX משלו — **לא נוגעים בו**. מאזינים ל-submit בשלב ה-capture
     (coexist בלי preventDefault), קוראים את הווריאנט הנבחר מה-form,
     וממפים ל-price דרך ה-JSON שהוזרק ליד הטופס (glow-pdp-atc-data). השדות במוסכמת
     glowItem (product_id/product_title/handle/item_category/price). fire-on-intent
     (industry-standard); guard מלא + try/catch — לעולם לא שובר את ה-add.
     value = הסכום של הכמות הזו לפי סולם הבאנדלים, מאותו <glow-ladder> שמציג אותו ללקוחה,
     בלי קריאה לעגלה (הירי סינכרוני ב-submit). בלי סולם: price×qty כמו קודם. */
  function ladderTotal(form, qty, unitCents) {
    var ladder = form.closest('glow-ladder');
    if (!ladder) {
      /* הכפתור הצף והקפסולה של v2 יושבים מחוץ ל-glow-ladder, באותו סקשן */
      var section = form.closest('.section-main-product, .section-gpv2-main');
      ladder = section && section.querySelector('glow-ladder');
    }
    if (!ladder || typeof ladder.totalFor !== 'function') return null;
    return ladder.totalFor(qty, unitCents);
  }

  function publishPdpAddToCart(form) {
    if (!window.Shopify || !window.Shopify.analytics
      || typeof window.Shopify.analytics.publish !== 'function') return;
    var dataEl = form.querySelector('.glow-pdp-atc-data');
    if (!dataEl) return;
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    if (!data || !data.product_id) return;
    try {
      var qtyInput = form.querySelector('[name="quantity"]');
      /* 30.9.2026 · טופס ה-sticky לא נושא כמות משלו: sticky-atc.js מעתיק אותה מהטופס
         הראשי רק אחרי המאזין הזה (capture רץ קודם). בלי זה הלחיצה הראשונה נרשמה 1
         והבאות את הכמות של הלחיצה הקודמת. מקור-האמת = בורר הכמות בטופס הראשי. */
      var stickyHost = form.closest('sticky-atc');
      if (stickyHost) {
        var mainQty = stickyHost.closest('.section-main-product');
        mainQty = mainQty && mainQty.querySelector('.quantity-submit-row [name="quantity"]');
        if (mainQty) qtyInput = mainQty;
      }
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? String(variantInput.value) : '';
      var price = 0;
      var total = null;
      if (data.variant_prices && data.variant_prices[variantId] != null) {
        price = data.variant_prices[variantId] / 100; /* סנטים → ש"ח */
        total = ladderTotal(form, qty, data.variant_prices[variantId]);
      }
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ILS';
      window.Shopify.analytics.publish('glow_add_to_cart', {
        item_list_name: form.getAttribute('data-glow-list') || 'pdp_main',
        product_id: data.product_id,
        product_title: data.product_title,
        handle: data.handle,
        item_category: data.product_type || '',
        price: price,
        quantity: qty,
        value: total !== null ? total / 100 : price * qty,
        currency: currency
      });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }

  document.addEventListener('submit', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;
    var form = target.closest('form.js-product-form[data-glow-list="pdp_main"]');
    if (!form) return;
    /* 30.9.2026 סבב 3: אין אירוע על ניסיון מכפתור נעול. disabled (מוצר שאזל) ממילא לא
       שולח submit, אבל aria-disabled="true" (ProductForm בזמן בקשה פתוחה, main.js) כן
       שולח, ו-ProductForm עוצר אותו: בלי הבדיקה הזו נרשם add_to_cart כפול על לחיצה כפולה. */
    var submitter = evt.submitter || form.querySelector('[name="add"]');
    if (submitter && (submitter.disabled || submitter.getAttribute('aria-disabled') === 'true')) return;
    publishPdpAddToCart(form);
  }, true);

  /* ---------- (2) קרוסלה מעגלית ל-related ---------- */

  var GlowCartCarousel = class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glow-carousel-track]');
      this.viewport = this.querySelector('[data-glow-carousel-viewport]');
      this.prevBtn = this.querySelector('[data-glow-carousel-prev]');
      this.nextBtn = this.querySelector('[data-glow-carousel-next]');
      if (!this.track || !this.viewport) return;

      /* כופה גלילה מיידית (לא מונפשת) על ה-viewport: הקפיצה המעגלית של הלולאה
         (recenter/jumpBy) חייבת להיות אינסטנט. אם CSS (שלנו או ירושה מ-Symmetry)
         מגדיר scroll-behavior:smooth, ה-jump הופך לאנימציה גלויה ו-jumpBy קורא
         scrollLeft באמצע אנימציה → יעד שגוי → "חוזר לתחילה". הכפיפה כאן מנטרלת
         זאת ברמת האלמנט. הגלילה החלקה של prev/next נשמרת דרך behavior:'smooth'
         המפורש ב-step(). */
      this.viewport.style.scrollBehavior = 'auto';

      this.rtl = document.dir === 'rtl';
      this.onPrev = this.step.bind(this, -1);
      this.onNext = this.step.bind(this, 1);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      /* לולאה מעגלית: מאזין לגלילה ומשכפל את הקצוות (clone-on-scroll) */
      this.onScroll = this.handleScroll.bind(this);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      /* re-clone כשה-cross-sell מזריק תוכן חדש (init של cc-cart-cross-sell) */
      this.observer = new MutationObserver(this.setupLoop.bind(this));
      this.observer.observe(this.track, { childList: true });
      this.setupLoop();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    /* בונה לולאה: משכפל את הפריטים פעם אחת לפני ואחרי, וממקם את הגלילה באמצע.
       גלילה לקצה קופצת בשקט לאמצע (seamless infinite).

       ⚠️ setupLoop משנה בעצמו את childList של ה-track (מסיר+מוסיף קלונים),
       וה-track נצפה ע"י this.observer. בלי הגנה זה יוצר לולאה אינסופית:
       מוטציה → observer יורה → setupLoop → מוטציה → ... = "Page Unresponsive".
       הגנה כפולה: (1) guard rebuilding נגד reentrancy (ה-callback אסינכרוני),
       (2) disconnect לפני המוטציה-העצמית + reconnect אחריה (כדי עדיין לתפוס
       הזרקות עתידיות של cc-cart-cross-sell). */
    setupLoop() {
      if (this.rebuilding) return;
      this.rebuilding = true;
      if (this.observer) this.observer.disconnect();
      try {
        this.originals = [...this.track.querySelectorAll('.glow-cart-related__item:not([data-glow-clone])')];
        if (this.originals.length < 2) {
          /* נקה קלונים ישנים גם כאן — אם ה-related ירד לפריט אחד/ריק */
          this.track.querySelectorAll('[data-glow-clone]').forEach(function (el) { el.remove(); });
          this.loopReady = false;
          return;
        }
        /* נקה קלונים ישנים */
        this.track.querySelectorAll('[data-glow-clone]').forEach(function (el) { el.remove(); });

        var frag = document.createDocumentFragment();
        var fragEnd = document.createDocumentFragment();
        this.originals.forEach(function (item) {
          var before = item.cloneNode(true);
          before.setAttribute('data-glow-clone', 'lead');
          frag.appendChild(before);
          var after = item.cloneNode(true);
          after.setAttribute('data-glow-clone', 'tail');
          fragEnd.appendChild(after);
        });
        this.track.insertBefore(frag, this.track.firstChild);
        this.track.appendChild(fragEnd);

        this.loopReady = true;
        /* מרכז את הגלילה על הבלוק המקורי (האמצעי) */
        requestAnimationFrame(this.recenter.bind(this, false));
      } finally {
        this.rebuilding = false;
        /* מנקה את התור של המוטציות-העצמיות שנצברו בזמן ה-rebuild
           (takeRecords) לפני ה-reconnect, כדי שלא ייספרו כהזרקה חיצונית */
        if (this.observer) {
          this.observer.takeRecords();
          this.observer.observe(this.track, { childList: true });
        }
      }
    }

    blockWidth() {
      /* רוחב בלוק אחד = סכום רוחב הפריטים המקוריים */
      var w = 0;
      this.originals.forEach(function (item) {
        w += item.getBoundingClientRect().width;
      });
      var style = getComputedStyle(this.track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      w += gap * this.originals.length;
      return w;
    }

    recenter(smooth) {
      if (!this.loopReady) return;
      var bw = this.blockWidth();
      /* ממקם בתחילת הבלוק המקורי (אחרי בלוק ה-lead) */
      this.viewport.scrollTo({
        left: this.rtl ? -bw : bw,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    handleScroll() {
      if (!this.loopReady) return;
      clearTimeout(this.scrollSettle);
      this.scrollSettle = setTimeout(this.wrapIfNeeded.bind(this), 80);
    }

    wrapIfNeeded() {
      if (!this.loopReady) return;
      var bw = this.blockWidth();
      /* scrollLeft ב-RTL הוא שלילי בדפדפנים מודרניים */
      var pos = Math.abs(this.viewport.scrollLeft);
      if (pos < bw * 0.5) {
        /* קרוב מדי לתחילת ה-lead → קפוץ קדימה בלוק */
        this.jumpBy(bw);
      } else if (pos > bw * 1.5) {
        /* נכנס ל-tail → קפוץ אחורה בלוק */
        this.jumpBy(-bw);
      }
    }

    jumpBy(delta) {
      var current = Math.abs(this.viewport.scrollLeft);
      var target = current + delta;
      this.viewport.scrollTo({ left: this.rtl ? -target : target, behavior: 'auto' });
    }

    step(dir) {
      if (!this.loopReady) {
        /* fallback: גלילה פשוטה אם אין מספיק פריטים ללולאה */
        var card = this.track.querySelector('.glow-cart-related__item');
        var amount = card ? card.getBoundingClientRect().width + 16 : 160;
        this.viewport.scrollBy({ left: (this.rtl ? -1 : 1) * dir * amount, behavior: 'smooth' });
        return;
      }
      var first = this.originals[0];
      var cardW = first ? first.getBoundingClientRect().width : 160;
      var style = getComputedStyle(this.track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var amount = (cardW + gap) * dir;
      this.viewport.scrollBy({ left: this.rtl ? -amount : amount, behavior: 'smooth' });
    }
  };

  if (!window.customElements.get('glow-cart-carousel')) {
    window.customElements.define('glow-cart-carousel', GlowCartCarousel);
  }

  /* ---------- (2.5) NIS → ש"ח בכל מחירי העגלה ----------
     ה-money_format של החנות מרנדר "NIS" (למשל "134.50 NIS"). הפתרון הקנוני
     הוא לשנות את money_format בהגדרות החנות ל-₪ — עד שזה יקרה, אנחנו מנרמלים
     טקסטואלית רק בתוך הקשר העגלה (drawer + עמוד /cart), בלי לגעת בשאר האתר. */
  var NIS_RE = /(\s*)NIS\b/g;

  function normalizeMoneyNode(node) {
    if (!node) return;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (textNode.nodeValue.indexOf('NIS') !== -1) {
        textNode.nodeValue = textNode.nodeValue.replace(NIS_RE, ' ש"ח');
      }
    }
  }

  function normalizeCartMoney() {
    var scopes = document.querySelectorAll('cart-drawer, .template-cart, cart-form');
    for (var i = 0; i < scopes.length; i += 1) {
      var money = scopes[i].querySelectorAll('.theme-money, .glow-bundle-summary__price, .glow-cart-related-card__price, .glow-cart-savings');
      for (var j = 0; j < money.length; j += 1) {
        normalizeMoneyNode(money[j]);
      }
    }
  }

  document.addEventListener('on:cart:after-merge', normalizeCartMoney);
  document.addEventListener('on:cart-drawer:after-open', normalizeCartMoney);
  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    window.requestAnimationFrame(normalizeCartMoney);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeCartMoney);
  } else {
    normalizeCartMoney();
  }

  /* ---------- (3) אנליטיקה — glow_checkout_click → begin_checkout (B2) ----------
     מדד-על. הקליק על "לתשלום" **מנווט מיד** (ניווט נייטיבי), ולכן אי אפשר לשלוף
     את העגלה על הקליק (fetch אסינכרוני היה מת עם הניווט). הפתרון: snapshot של
     /cart.js שנטען מראש ומתרענן על אותם אירועים כמו normalizeCartMoney, וה-publish
     בזמן הקליק הוא **סינכרוני** מתוך ה-snapshot. ה-sendMP בפיקסל הוא keepalive,
     כך שה-Measurement Protocol שורד את הניווט.

     המאזין **פסיבי לחלוטין**: בלי preventDefault/stopPropagation, בלי עיכוב —
     הניווט לא מושהה. כשהשער חסום (aria-disabled/disabled או container חסום)
     לא יורים כלל. guard מלא + try/catch — אנליטיקה לעולם לא שוברת ניווט. */
  var _glowCartSnapshot = null;

  /* ---------- מצב QA (עילי בודק את האתר כל היום) ----------
     דגל localStorage `glow_qa` = "1" מוציא את הדפדפן מכל מסילות המדידה של
     הקליק-לתשלום, בלי לגעת בחוויית הגלישה עצמה:
       (א) glowCheckoutBeacon לא נורה  → אין רשומה ביומן העגלות (KV);
       (ב) glowRescueFlag לא נכתב      → פופאפ ההצלה לא יקפוץ לו בטעות;
       (ג) cart attribute glow_qa="1"  → מסילות ה-webhook (carts/*, checkouts/*)
           רצות בצד-שרת ועיוורות ל-localStorage; ה-attribute נוסע עם העגלה,
           וה-Hub מדלג על הרשומה.
     הדלקה/כיבוי: ?glow_qa=1 / ?glow_qa=0 בכתובת (נקרא ב-glow-attrib.liquid).
     מסילת ה-BQ מכוסה בנפרד ב-glow-insights (QA_GA_USERS · מזהה GA יציב). */
  function glowQaOn() {
    try { return localStorage.getItem('glow_qa') === '1'; } catch (e) { return false; }
  }

  /* סנכרון ה-attribute · פעם אחת בטעינת דף, ורק כשיש עגלה. כשהדגל כבוי וה-attribute
     עדיין תקוע על העגלה (עילי כיבה את המצב) — מנקים אותו ב-"" (הדרך של שופיפיי
     למחוק attribute). כשל לעולם לא נוגע ב-UX. */
  function glowQaSyncCartAttr() {
    try {
      if (typeof fetch !== 'function') return;
      var want = glowQaOn() ? '1' : '';
      fetch(CART_ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.item_count) return null; /* עגלה ריקה — אין מה לסמן */
          var current = (cart.attributes || {}).glow_qa || '';
          if (current === want) return null;
          if (!want && !current) return null;
          return fetch(CART_ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'content-type': 'application/json', accept: 'application/json' },
            body: JSON.stringify({ attributes: { glow_qa: want } })
          });
        })
        .catch(function () { /* שקט */ });
    } catch (e) { /* שקט */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', glowQaSyncCartAttr);
  } else {
    glowQaSyncCartAttr();
  }

  function refreshCartSnapshot() {
    try {
      fetch(CART_ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart && cart.items) { _glowCartSnapshot = cart; glowCartGeoBeacon(cart); } })
        .catch(function () { /* לא-חוסם — נשאר ה-snapshot הקודם */ });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }

  document.addEventListener('on:cart:after-merge', refreshCartSnapshot);
  document.addEventListener('on:cart-drawer:after-open', refreshCartSnapshot);
  document.addEventListener('dispatch:cart-drawer:refresh', refreshCartSnapshot);

  /* טעינה ראשונית: בעמוד /cart אין אירוע drawer-open, אז שולפים על טעינת הדף.
     בשאר העמודים ה-snapshot נטען כשה-drawer נפתח (on:cart-drawer:after-open) —
     בלי לשלם בקשה מיותרת בכל pageview. */
  function primeCartSnapshot() {
    if (document.querySelector('.template-cart')) refreshCartSnapshot();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeCartSnapshot);
  } else {
    primeCartSnapshot();
  }

  /* מבנה ה-payload זהה בדיוק לקודם (המנוי בפיקסל מעביר items[] as-is בשמות
     GA4 — item_id/item_name — ולא דרך glowItem). */
  function publishCheckoutClick() {
    var cart = _glowCartSnapshot;
    if (!cart || !cart.items || !cart.items.length) return;
    /* דגל ההצלה נרשם ראשון ובלי תנאי: הוא אינו אנליטיקה, והוא חייב להתקיים גם
       כשאובייקט Shopify.analytics חסום/חסר (חוסם פרסומות, סשן ישן). */
    glowRescueFlag(cart);
    if (!window.Shopify || !window.Shopify.analytics
      || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      var currency = cart.currency
        || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ILS';
      var items = cart.items.map(function (i) {
        return {
          item_id: String(i.product_id),
          item_name: i.product_title,
          quantity: i.quantity,
          price: i.final_price / 100
        };
      });
      window.Shopify.analytics.publish('glow_checkout_click', {
        items: items,
        value: cart.total_price / 100,
        currency: currency,
        item_count: cart.item_count
      });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
    glowCheckoutBeacon(cart);
  }

  /* 🔴 נירמול token העגלה (נתפס ב-E2E סטייג'ינג 19.8): cart.token מ-/cart.js מגיע
     כ-"hWNFqEChC4qQjZ6gVtLTg7Rz?key=bfc5793089a…" (סיומת אימות-בעלות לדפדפן), בעוד
     ה-webhooks של שופיפיי מדווחים token נקי. בלי נירמול, אותה עגלה נושאת שתי זהויות
     שונות בין המסילות. חותכים ב-"?" **לפני** ה-slice · אחרת חותכים באמצע ה-key. */
  function normalizeCartToken(raw) {
    return String(raw == null ? '' : raw).split('?')[0].slice(0, 40);
  }

  /* 🔴 מזהה המכשיר של GA4 (client_id) — עוגן-הזהות השני ביומן העגלות (20.8).
     הבאג שזה פותר: רשומת "click" מה-beacon נשאה token בלבד, ורשומת "ga4" מ-BigQuery
     נושאת gaUser בלבד — אותה לקוחה בלי אף מזהה משותף. groupClicksByIdentity
     (glow-insights) לא הצליח לאחות אותן ברגע הלחיצה, פתח שורה חדשה, והקאונטר קפץ
     ב-1 עד שה-BQ הדביקה ומיזגה אותן בחזרה. שליחת ה-client_id כבר מהקליק סוגרת את החלון.

     הפורמט חייב להיות זהה 1:1 לזה שב-BigQuery (`<random>.<timestamp>`), כלומר שני
     המקטעים האחרונים של הקוקי `_ga` (GA1.1.268816855.1786999189 → 268816855.1786999189)
     בלי הקידומת. הקוקי נשלח as-is — לא "מתקנים" ערכים חריגים.

     פרטיות: מזהה פסאודונימי שכבר קיים אצלנו בכל רשומת ga4 ביומן; אין כאן מידע חדש,
     רק חיבור בין מה שכבר יש. ⛔ בלי gclid/fbclid או כל click-ID (החלטת פרטיות).
     אין קוקי (לא אושרו קוקיז / מצב פרטי) → מחזיר '' ו**השדה לא נשלח כלל**.
     try/catch שקט — כשל לעולם לא נוגע בקליק "לתשלום". */
  function glowGaClientId() {
    try {
      if (!document.cookie) return '';
      var m = document.cookie.match(/(?:^|;\s*)_ga=([^;]*)/); /* לא תופס _ga_<MID> */
      if (!m || !m[1]) return '';
      var parts = decodeURIComponent(m[1]).split('.');
      if (parts.length < 4) return '';
      var cid = parts.slice(-2).join('.');
      return /^\d+\.\d+$/.test(cid) ? cid : '';
    } catch (e) { return ''; }
  }

  /* דגל הצלת-עגלה (סשן): נרשם בכל קליק "לתשלום" ונקרא ע"י glow-cart-rescue.liquid ·
     לקוחה שחזרה מהקופה לעמוד-אתר עם דגל טרי (≤30 דק') רואה את פופאפ ההצלה.
     hasCode = קוד-הנחה (discount_code) מוחל בעגלה · קובע את גרסת הפופאפ (5% / שמירה).
     הנחות אוטומטיות (באנדלים) אינן "קוד". sessionStorage בלבד; כשל לעולם לא נוגע בניווט. */
  function glowRescueFlag(cart) {
    try {
      if (glowQaOn()) return; /* מצב QA — בלי דגל, ולכן גם בלי פופאפ הצלה */
      var hasCode = false;
      try {
        var apps = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
        for (var i = 0; i < apps.length; i += 1) {
          if (apps[i] && apps[i].type === 'discount_code') { hasCode = true; break; }
        }
        if (!hasCode && Array.isArray(cart.items)) {
          outer:
          for (var j = 0; j < cart.items.length; j += 1) {
            var allocs = cart.items[j] && cart.items[j].line_level_discount_allocations;
            if (!Array.isArray(allocs)) continue;
            for (var k = 0; k < allocs.length; k += 1) {
              var da = allocs[k] && allocs[k].discount_application;
              if (da && da.type === 'discount_code') { hasCode = true; break outer; }
            }
          }
        }
      } catch (err) { hasCode = false; }
      sessionStorage.setItem('glow_rescue', JSON.stringify({
        ts: Date.now(),
        token: normalizeCartToken(cart.token) || null,
        count: cart.item_count || 0,
        total: Math.round(cart.total_price || 0) / 100,
        hasCode: hasCode
      }));
    } catch (e) { /* private mode · בלי דגל, בלי נזק */ }
  }

  /* דגל "לחצה לתשלום" לסשן · אות-הנוכחות (glow-presence-beacon) מצרף אותו לפינג הבא,
     כך שהדשבורד יודע כמה מהגולשות שבאתר כרגע כבר לחצו. sessionStorage בלבד, בלי קוקי. */
  function markClicked() {
    try { sessionStorage.setItem('glow_clicked', '1'); } catch (e) { /* private mode */ }
  }

  /* יומן העגלות (Hub · CARTLOG): כל לחיצת "לתשלום" — אנונימית או מזוהה — נשלחת
     ל-Worker עם תכולת העגלה המלאה. אותו מנגנון sendBeacon+Blob text/plain המוכח
     של ה-ingest (שורד ניווט-דף, בלי preflight). מייל: זיכרון-ההרשמה של הדפדפן
     (glow_known_email — נכתב ב-glowHubIngest בכל הרשמה) → מסע-הלקוחה מתעדכן גם
     כשלא הוקלד מייל בצ'קאאוט. כשל כאן לעולם לא נוגע בניווט. */
  function glowCheckoutBeacon(cart) {
    try {
      if (glowQaOn()) return; /* מצב QA — הקליק לא נרשם ביומן העגלות */
      var email = '';
      try { email = localStorage.getItem('glow_known_email') || ''; } catch (e) { /* private mode */ }
      var items = (cart.items || []).map(function (i) {
        var lineCents = (typeof i.final_line_price === 'number') ? i.final_line_price
          : (typeof i.line_price === 'number') ? i.line_price : 0;
        var unitCents = (typeof i.final_price === 'number') ? i.final_price
          : (typeof i.price === 'number') ? i.price : 0;
        return { title: i.product_title, qty: i.quantity,
          line_price: Math.round(lineCents) / 100, unit_price: Math.round(unitCents) / 100 };
      });
      if (!items.length) return;
      var detail = { cart: {
        items: items,
        count: cart.item_count,
        original_total: Math.round(cart.original_total_price || 0) / 100,
        discount: Math.round(cart.total_discount || 0) / 100,
        total: Math.round(cart.total_price || 0) / 100,
        currency: cart.currency || 'ILS',
        /* token העגלה · עוגן-הזהות של יומן העגלות (שורה אחת ללקוחה; יציב בין ביקורים).
           מנורמל, אחרת ה-token של ה-beacon לא יצליב מול ה-token של ה-webhooks. */
        token: normalizeCartToken(cart.token) || null
      } };
      /* מזהה GA4 (client_id) · עוגן-הזהות השני. **תוספת אופציונלית** — נוסף רק כשיש
         קוקי תקין; בלי קוקי השדה פשוט לא קיים ב-payload (לא ריק, לא null). */
      var gaUser = glowGaClientId();
      if (gaUser) detail.cart.gaUser = gaUser;
      /* מקור-הקמפיין שנלכד ב-glow-attrib.liquid (סיווג בלבד: google/meta/ig_bio/…,
         בלי click-IDs). טרי עד 30 יום. נוסף פעם אחת — עובר גם ב-glowHubIngest וגם ב-fallback. */
      try {
        var attribRaw = localStorage.getItem('glow_attrib');
        if (attribRaw) {
          var at = JSON.parse(attribRaw);
          if (at && at.src && (Date.now() - (Number(at.ts) || 0)) < 2592000000) {
            detail.attrib = {
              src: String(at.src).slice(0, 24),
              camp: (at.camp != null) ? String(at.camp).slice(0, 48) : null
            };
          }
        }
      } catch (err) { /* private mode / JSON פגום — בלי אטריביושן */ }
      if (typeof window.glowHubIngest === 'function') {
        window.glowHubIngest(email, 'checkout', detail);
        markClicked();
        return;
      }
      /* fallback עצמאי — אם ה-snippet של הפוטר לא נטען משום סיבה */
      var payload = new Blob([JSON.stringify({ email: email, source: 'checkout', detail: detail })], { type: 'text/plain' });
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon('https://glow-customer-hub.glowvitamininsights.workers.dev/ingest', payload)); } catch (err) { sent = false; }
      if (!sent) {
        fetch('https://glow-customer-hub.glowvitamininsights.workers.dev/ingest', { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(function () {});
      }
      markClicked();
    } catch (e) { /* לא-קריטי */ }
  }

  /* beacon עיר לעגלה חיה (Hub · CARTLOG). שורות "🛒 עגלה" ביומן מגיעות
     מ-webhook של שופיפיי שאין בו IP, ולכן אין להן תג-עיר. ה-beacon הזה שולח
     מהדפדפן את **token העגלה בלבד**, וה-Hub פותר עיר מה-IP בקצה ושומר geo:<token>.
     פרטיות: בלי פריטים, בלי מחירים, בלי מייל · ה-IP לא נשמר אצלנו · עיר בלבד.
     פעם אחת לכל token בסשן (sessionStorage · glow_geo_token). במצב פרטי,
     כש-sessionStorage זורק, שולחים בכל פעם · ה-Hub אידמפוטנטי (אותו מפתח).
     לא תלוי consent, כמו beacon הקליק: ה-Hub רואה את כולן, GA רק את המסכימות.
     כשל כאן לעולם לא נוגע ב-UX. */
  function glowCartGeoBeacon(cart) {
    try {
      if (glowQaOn()) return; /* מצב QA · בלי תג-עיר, כמו beacon הקליק */
      if (!cart || !cart.item_count) return; /* עגלה ריקה · אין מה לתייג */
      var token = normalizeCartToken(cart.token);
      if (!token) return;
      var already = false;
      try { already = sessionStorage.getItem('glow_geo_token') === token; } catch (e) { already = false; }
      if (already) return;
      var url = 'https://glow-customer-hub.glowvitamininsights.workers.dev/ingest';
      var payload = new Blob([JSON.stringify({ email: '', source: 'cart', detail: { cart: { token: token } } })], { type: 'text/plain' });
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, payload)); } catch (err) { sent = false; }
      if (!sent) {
        fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(function () {});
      }
      try { sessionStorage.setItem('glow_geo_token', token); } catch (e) { /* private mode · יישלח שוב */ }
    } catch (e) { /* לא-קריטי */ }
  }

  /* מאזין יחיד (click בשלב ה-bubble) — גם כפתור ה-checkout הרגיל וגם כפתורי
     התשלום המהיר. ⚠️ אירוע אחד בלבד: אין מאזין submit מקביל, כדי שהכפתור
     name="checkout" שבתוך ה-form בעמוד /cart לא ייספר פעמיים. */
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;

    var checkoutBtn = target.closest('.glow-checkout-btn');
    if (checkoutBtn) {
      if (checkoutBtn.getAttribute('aria-disabled') === 'true' || checkoutBtn.disabled === true) return;
      if (checkoutBtn.closest('.glow-checkout--blocked')) return;
      publishCheckoutClick();
      return;
    }

    var dyn = target.closest('.shopify-payment-button, .additional-checkout-buttons, .dynamic-checkout__content');
    if (!dyn) return;
    /* רק בהקשר עגלה — לא ה-buy-it-now של ה-PDP */
    if (!dyn.closest('cart-form') && !dyn.closest('.template-cart')) return;
    if (dyn.closest('.glow-checkout--blocked')) return;
    publishCheckoutClick();
  });

  /* ---------- (4) אנליטיקה — glow_signup → sign_up (B4) ----------
     המסלול היחיד בתמה = טופס create_customer הקלאסי (main-register.liquid;
     data-glow-signup). **אות-הצלחה, לא ניסיון:** דגל ב-submit, ואחרי ה-redirect —
     אם עזבנו את עמוד ההרשמה (הרשמה מוצלחת → ניווט אל /account) והדגל טרי → publish.
     כישלון נשאר בעמוד ההרשמה (הטופס עדיין קיים) → לא יורה, בלי ניפוח.
     ⚠️ החנות על NCA (New Customer Accounts) — ההרשמה בפועל היא ב-flow המתארח של
     Shopify (off-theme), לכן המסלול הזה תופס רק הרשמות דרך הטופס הקלאסי אם בכלל
     נגיש. guard מלא + try/catch — לא-קריטי. */
  var SIGNUP_PENDING_KEY = 'glow_signup_pending';
  var SIGNUP_TS_KEY = 'glow_signup_ts';
  var SIGNUP_FRESH_MS = 5 * 60 * 1000;

  function clearSignupFlags() {
    try {
      sessionStorage.removeItem(SIGNUP_PENDING_KEY);
      sessionStorage.removeItem(SIGNUP_TS_KEY);
    } catch (e) { /* noop */ }
  }

  document.addEventListener('submit', function (evt) {
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;
    var form = target.closest('form[data-glow-signup]');
    if (!form) return;
    try {
      sessionStorage.setItem(SIGNUP_PENDING_KEY, form.getAttribute('data-glow-signup') || 'email');
      sessionStorage.setItem(SIGNUP_TS_KEY, String(Date.now()));
    } catch (e) { /* incognito */ }
  });

  function handleSignupPostback() {
    var method = '', ts = 0;
    try {
      method = sessionStorage.getItem(SIGNUP_PENDING_KEY) || '';
      ts = parseInt(sessionStorage.getItem(SIGNUP_TS_KEY) || '0', 10);
    } catch (e) { return; }
    if (!method) return;
    clearSignupFlags(); /* one-shot */
    if (!ts || (Date.now() - ts) > SIGNUP_FRESH_MS) return;        /* דגל ישן */
    if (document.querySelector('form[data-glow-signup]')) return;   /* עדיין בעמוד ההרשמה = כישלון/re-render */
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish('glow_signup', { method: method });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleSignupPostback);
  } else {
    handleSignupPostback();
  }

  /* ---------- (5) אנליטיקה — glow_faq_view (B5) ----------
     אקורדיוני FAQ נייטיביים (<details>): PDP (.glow-faq__item, עם product_id) +
     מרכז העזרה (.glow-faq-page__item). ירי על **פתיחה בלבד** (el.open===true) —
     אירוע toggle **לא עושה bubble**, אבל בשלב ה-capture הוא נתפס גם על document.
     data-glow-faq-question = טקסט השאלה (נקי, בלי גירוד אייקון). לא-קריטי. */
  document.addEventListener('toggle', function (evt) {
    var el = evt.target;
    if (!el || typeof el.hasAttribute !== 'function' || !el.hasAttribute('data-glow-faq-question')) return;
    if (!el.open) return; /* פתיחה בלבד — לא על סגירה */
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      var payload = { faq_question: el.getAttribute('data-glow-faq-question') || '' };
      var pid = el.getAttribute('data-glow-faq-product-id');
      if (pid) payload.product_id = pid;
      window.Shopify.analytics.publish('glow_faq_view', payload);
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }, true);
})();
